import { render, staticRenderFns } from "./index.vue?vue&type=template&id=520925f0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520925f0",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/reflushPage/index.vue
// module id = null
// module chunks = 